/**
 * Человеческое имя типа чата.
 *
 * Различие канала и супергруппы важно не формально: в канале сотрудник
 * читатель, а не собеседник, и ждать там ответа бессмысленно. Раньше оба
 * приходили как supergroup и выглядели одинаково.
 */
export const CHAT_TYPE_LABELS: Record<string, string> = {
  private: 'Личный',
  group: 'Группа',
  supergroup: 'Группа',
  channel: 'Канал',
  secret: 'Секретный',
  unknown: 'Неизвестно',
};

/** Показывать метку у личных чатов незачем: это случай по умолчанию. */
export function chatTypeBadge(type: string): string | null {
  if (type === 'private' || type === 'unknown') return null;
  return CHAT_TYPE_LABELS[type] ?? type;
}
